import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	wrapperStyles,
	labelStyles,
	inputStyles,
	errorStyles,
	optionalEditStyles,
	labelEditStyles,
	inputEditStyles,
	inputSizeStyles,
	inputSizeEditStyles,
} from '@/css/shared/inputs.css';

const getStyles = (formStyles) =>
	css(wrapperStyles(formStyles), inputSizeStyles(), {
		'.supt-inputText__label': labelStyles(formStyles),
		'.supt-inputText__input': inputStyles(formStyles),
		'.supt-inputText__error': errorStyles(formStyles),

		'&.supt-inputField--error': {
			'.supt-inputText__input': {
				borderColor: formStyles.error?.color,
			},
		},
	});

// edit
const getEditStyles = (formStyles) =>
	css({
		'.supt-inputText__optional': optionalEditStyles(formStyles),
		'.supt-inputText__input': inputEditStyles(formStyles),
		'.supt-inputText__label': labelEditStyles(),
	});

const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/input-text"]': inputSizeEditStyles(),
	});

export { getStyles, getEditStyles, getEditGlobalStyles };
